var _defs, _path, _path2, _rect, _rect2, _path3, _path4, _path5, _polygon, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _rect12, _rect13, _circle, _circle2, _circle3, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyzeReport4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 436.55 333.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 210.85,
    y1: 295.1,
    x2: 236.54,
    y2: 295.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5c5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#ead4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0e9cb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 180.87,
    y1: 295.1,
    x2: 206.56,
    y2: 295.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 248.43,
    y1: 174.15,
    x2: 251.13,
    y2: 121.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 227.88,
    y1: 271.22,
    x2: 249.68,
    y2: 167.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 227.88,
    y1: 285.3,
    x2: 249.68,
    y2: 181.45,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 244.63,
    y1: -96.59,
    x2: 248,
    y2: 225.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#fff",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fff",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 242.92,
    y1: -82.12,
    x2: 245.98,
    y2: 210.16,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 307.17,
    y1: 66.7,
    x2: 353.34,
    y2: 130.52,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 212.14,
    y1: 91.15,
    x2: 110.5,
    y2: 258.13,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 181.71,
    y1: 163.61,
    x2: 198.3,
    y2: 163.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 151.38,
    y1: 136.86,
    x2: 164.86,
    y2: 136.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 164.86,
    y1: 154.54,
    x2: 146.41,
    y2: 112.45,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 175.37,
    y1: 136.68,
    x2: 191.17,
    y2: 136.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 235.14,
    y1: 202.47,
    x2: 256.67,
    y2: 202.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 152.03,
    y1: 118.21,
    x2: 179.75,
    y2: 118.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 99.06,
    y1: 217.02,
    x2: 209.68,
    y2: 217.02,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 178.21,
    y1: 199.52,
    x2: 101.14,
    y2: 306.89,
    xlinkHref: "#linear-gradient-3"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Analyze Report 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M77.14,338.63l91.14,4,22.55,1c24.45,1.06,48.91,2.13,73.37,1.95,20.48-.14,40.95-1.16,61.4-2.17L393.79,340c5.2-.26,12.43-4.52,9.11-8.53,16.65-18.43,30.2-41.62,33.88-66.18s-1.6-50.78-16.41-70.72c-11.17-15-28.28-28.65-27.67-47.37.36-11.27,7.47-21.59,7.28-32.86-.18-10.84-7.26-20.62-16.14-26.82S364.39,78,354,74.88c-40.53-12.32-88.29-25.15-130.57-22.36s-85,20.48-110.68,54.21c-5.65,7.43-10.49,15.61-17.43,21.84-12.5,11.24-30,14.68-44.94,22.34C26.89,163,9.72,186.17,3.81,211.92S3,265.51,16.43,288.24c7.07,11.94,16.29,22.44,25.44,32.87,5,5.71,10.16,11.53,16.81,15.2S70.61,342.5,77.14,338.63Z",
    transform: "translate(-1.36 -20.6)",
    fill: "#2f55d4",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M223.72,321.27a4.77,4.77,0,0,0,.7,3.34,5.32,5.32,0,0,0,2.8,1.36,21.91,21.91,0,0,1,9.32,5.45,58.29,58.29,0,0,1-22.9.74,2.66,2.66,0,0,1-2.78-3.25l.51-62.16c0-5.44,3.89-11.72,10.3-8.72,5.4,2.52,4,10.13,3.8,14.87Q224.58,297.08,223.72,321.27Z",
    transform: "translate(-1.36 -20.6)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.73,321.27a4.83,4.83,0,0,0,.7,3.34,5.39,5.39,0,0,0,2.8,1.36,22,22,0,0,1,9.33,5.45,58.34,58.34,0,0,1-22.91.74,3.5,3.5,0,0,1-2.33-1.08,3.55,3.55,0,0,1-.45-2.17l.51-62.16c.05-5.44,3.9-11.72,10.3-8.72,5.4,2.52,4,10.13,3.8,14.87Q194.61,297.08,193.73,321.27Z",
    transform: "translate(-1.36 -20.6)",
    fill: "url(#linear-gradient-2)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 215.43,
    y: 136.16,
    width: 67.84,
    height: 40.31,
    fill: "#2f55d4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 215.43,
    y: 136.16,
    width: 67.84,
    height: 40.31,
    fill: "url(#linear-gradient-3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M390.47,340.12h-21V247.71a29.87,29.87,0,0,0-29.84-29.84h-232a29.87,29.87,0,0,0-29.84,29.84v92.41H56.88V247.71a50.85,50.85,0,0,1,50.79-50.79h232a50.85,50.85,0,0,1,50.79,50.79Z",
    transform: "translate(-1.36 -20.6)",
    fill: "#2f55d4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M390.47,247.71v92.41h-21V247.71a29.88,29.88,0,0,0-29.84-29.84h-232a29.88,29.88,0,0,0-29.84,29.84v92.41H56.88V247.71a50.85,50.85,0,0,1,50.79-50.79h232A50.85,50.85,0,0,1,390.47,247.71Z",
    transform: "translate(-1.36 -20.6)",
    fill: "url(#linear-gradient-4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M390.47,261.79V354.2h-21V247.71a29.88,29.88,0,0,0-29.84-29.84h-232a29.88,29.88,0,0,0-29.84,29.84V354.2H56.88V261.79A50.85,50.85,0,0,1,107.67,211h232A50.85,50.85,0,0,1,390.47,261.79Z",
    transform: "translate(-1.36 -20.6)",
    fill: "url(#linear-gradient-5)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "227.6 178.19 291.88 178.19 270.54 189.71 211.29 189.71 227.6 178.19",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 138.75,
    width: 215.3,
    height: 144.52,
    rx: 10.58,
    fill: "#2f55d4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 138.75,
    width: 215.3,
    height: 144.52,
    rx: 10.58,
    fill: "url(#linear-gradient-6)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 136.87,
    y: 5.63,
    width: 215.3,
    height: 130.94,
    rx: 10.07,
    fill: "url(#linear-gradient-7)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 176.89,
    y: 45.95,
    width: 7.32,
    height: 55.98,
    fill: "#2f55d4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 189.36,
    y: 55.94,
    width: 7.32,
    height: 45.99,
    fill: "#2f55d4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 202.09,
    y: 45.95,
    width: 7.32,
    height: 55.98,
    fill: "#2f55d4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 214.56,
    y: 68.46,
    width: 7.32,
    height: 33.46,
    fill: "#2f55d4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 227.29,
    y: 45.95,
    width: 7.32,
    height: 55.98,
    fill: "#2f55d4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 239.75,
    y: 62.75,
    width: 7.32,
    height: 39.18,
    fill: "#2f55d4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M312.85,51.2a27.23,27.23,0,0,0-.16,54.46V96.18h-.11a18,18,0,1,1,18-18,16.81,16.81,0,0,1-.19,2.57H340a22,22,0,0,0,.11-2.3A27.23,27.23,0,0,0,312.85,51.2Z",
    transform: "translate(-1.36 -20.6)",
    fill: "#2f55d4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M340,80.73a27.2,27.2,0,0,1-27.12,24.93h-.16V96.18A18,18,0,0,0,330.4,80.73Z",
    transform: "translate(-1.36 -20.6)",
    fill: "url(#linear-gradient-8)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M199.58,151.84c-.4-4.61-.88-9.33-2.83-13.53s-5.64-7.88-10.22-8.56a3.79,3.79,0,0,0-1.71.07c-1.1.36-1.74,1.47-2.57,2.27s-2.38,1.22-3,.26c.78-3.26,4-5.66,4.3-9a10.93,10.93,0,0,0-.7-4.29q-2-6.37-4.43-12.61c-.41-1.06-1-2.25-2.07-2.56a3.4,3.4,0,0,0-2.28.38c-5.24,2.38-8.63,7.55-11.18,12.71-2.22,4.51-4.05,9.4-3.81,14.42.16,3.37,1.25,6.64,1.59,10,.3,3,0,6.27,1.45,9,2.81,5.26,10.32,5.52,14.91,9.33,1.47,1.22,2.68,2.83,4.45,3.52,1,.41,1.74,1.19,2.85,1.23,3.47.14,16.75.43,16.75.43S199.84,154.86,199.58,151.84Z",
    transform: "translate(-1.36 -20.6)",
    fill: "url(#linear-gradient-9)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M173.67,95.82A5.89,5.89,0,0,1,175.48,97a10.78,10.78,0,0,1,2.6,12.21,4,4,0,0,1-1.18,1.61,8.3,8.3,0,0,0-1.19.81.6.6,0,0,1-.28.22.58.58,0,0,1-.29,0,20.9,20.9,0,0,1-6.26-3.41,20.81,20.81,0,0,1-4.22-6.25c-.95-1.87-1.18-4.92,1-6.17a6.14,6.14,0,0,1,3.11-.55A14.42,14.42,0,0,1,173.67,95.82Z",
    transform: "translate(-1.36 -20.6)",
    fill: "#3e3e54"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M181.71,153.51l.41-10.59,8.4-1.47,7.78,44.31s-12-7.55-12.54-8.66S181.71,153.51,181.71,153.51Z",
    transform: "translate(-1.36 -20.6)",
    fill: "url(#linear-gradient-10)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M254.64,98.76",
    transform: "translate(-1.36 -20.6)",
    fill: "none",
    stroke: "#916972",
    strokeMiterlimit: 10,
    strokeWidth: 1.31
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M151.41,143.38a2.92,2.92,0,0,0,.14,1.5,2.07,2.07,0,0,0,.83.83,7.34,7.34,0,0,0,3.45.73c2.48.08,5,.08,7.44,0,.56,0,1.22-.12,1.47-.61a1.69,1.69,0,0,0,.12-.77l-.1-9.05a17.25,17.25,0,0,0-.29-3.52,6.82,6.82,0,0,0-3.41-4.66,6.39,6.39,0,0,0-5.16-.08,7.71,7.71,0,0,0-3.21,2.38,4.84,4.84,0,0,0-.63,3C151.91,136.55,151.7,140,151.41,143.38Z",
    transform: "translate(-1.36 -20.6)",
    fill: "url(#linear-gradient-11)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M163.78,137.2a2.42,2.42,0,0,1-2.49.65,6.21,6.21,0,0,1-2.31-1.41,31.42,31.42,0,0,1-2.44-2.32,5,5,0,0,0-1,3.15c.06,1.19.53,2.38.25,3.54a5.53,5.53,0,0,1-1.59,2.37l-1.94,2c-.21.22-.48.46-.77.39a.89.89,0,0,1-.38-.26c-.61-.61-1.19-1.23-1.75-1.87a3.23,3.23,0,0,1-.63-.94,3.42,3.42,0,0,1-.13-1.35l.11-2.65a5.09,5.09,0,0,1,.24-1.6,8.89,8.89,0,0,1,.85-1.42,27.25,27.25,0,0,0,1.3-2.79,12.28,12.28,0,0,1,2.26-3.32,4.25,4.25,0,0,1,1.7-1.21,4.81,4.81,0,0,1,1.42-.18,50.6,50.6,0,0,1,5.08.1,4.38,4.38,0,0,1,1.3.22c1.53.6,3.13,2.74,2.49,4.4-.23.59-.68,1-.88,1.65C164.2,135.31,164.43,136.39,163.78,137.2Z",
    transform: "translate(-1.36 -20.6)",
    fill: "url(#linear-gradient-12)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M170.9,145.22c8.22,2.1,16,7.2,19.72,14.81,1.83,3.71,2.63,7.81,3.49,11.86Q197,185.68,201,199.22a1.79,1.79,0,0,0,.62,1.08,1.82,1.82,0,0,0,1.18.16q15.06-1.26,30.18-1.75A3.81,3.81,0,0,1,235,199a3.49,3.49,0,0,1,1.38,1.82,22.59,22.59,0,0,1,1.86,9.1q-16.37,4.08-33,6.88c-6.12,1-12.91,1.8-18.08-1.64-3.8-2.53-5.94-6.86-7.9-11q1.8,8.22,2.85,16.58a5,5,0,0,1-.48,3.62,5,5,0,0,1-3.37,1.5,117.27,117.27,0,0,1-29.65.9,5.17,5.17,0,0,1-5.45-4.7c-3.94-13.14-3.73-27.2-7-40.53-.89-3.62-2-7.19-2.59-10.89a44.31,44.31,0,0,1,0-11.39c.55-4.81,2.55-11.24,7.45-13.36,1.87-.81,4.09-.83,6.08-1.09a98.71,98.71,0,0,1,11.13-1A48.93,48.93,0,0,1,170.9,145.22Z",
    transform: "translate(-1.36 -20.6)",
    fill: "#2f55d4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M175.48,134.5a2,2,0,0,0,1.22,2.64c.77.15,1.63-.31,2.31.06s.72,1.55.84,2.43a4.72,4.72,0,0,0,2.27,3.29,6.72,6.72,0,0,0,4,.86,5.56,5.56,0,0,0,4.44-2.33,5.1,5.1,0,0,0,.47-3.87,10,10,0,0,0-1.83-3.52c-1.51-2-4.4-4.75-7.15-4.49C179.91,129.76,176.15,132.49,175.48,134.5Z",
    transform: "translate(-1.36 -20.6)",
    fill: "url(#linear-gradient-13)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M242.8,196.17a7,7,0,0,1,2.26-.76,5.53,5.53,0,0,1,2.59.47c3.17,1.25,5.6,3.89,7.57,6.67.9,1.27,1.77,2.81,1.34,4.3a3.79,3.79,0,0,1-2.61,2.38,11.23,11.23,0,0,1-3.66.28l-8.91-.31a6.27,6.27,0,0,1-2.51-.44c-1.58-.77-2.2-2.67-2.65-4.38-.3-1.12-1.16-2.86-1.07-4,.07-1,.2-.8,1.07-1.12C238.48,198.41,240.59,197.2,242.8,196.17Z",
    transform: "translate(-1.36 -20.6)",
    fill: "url(#linear-gradient-14)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M244.12,196.71a1.81,1.81,0,0,0,.64,1,1.88,1.88,0,0,0,.91.18l2.35,0a47.28,47.28,0,0,0-3.31-8.63l-2.54-5.51c-.37-.78-.83-1.65-1.66-1.87-1-.27-3.1.71-3,1.88s1.83,2.95,2.38,3.91A69.54,69.54,0,0,1,244.12,196.71Z",
    transform: "translate(-1.36 -20.6)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M200.38,232.7c8.23.5,16.51,2.35,23.66,6.46s13.11,10.62,15.54,18.5l-24.4,12.75a5.51,5.51,0,0,1-2.54.84c-1.35,0-2.47-1-3.51-1.82a40.59,40.59,0,0,0-14.63-8c-10.79-3.1-22.39-.73-33.48-2.4a20.2,20.2,0,0,1-8.14-2.73c-4.07-2.68-6.3-7.52-6.94-12.35s.11-9.72.85-14.53a6.27,6.27,0,0,1,1.31-3.49,6.07,6.07,0,0,1,2.93-1.4c7.52-2,18.46-6.27,25.45-1.26,3.05,2.19,5.36,5.1,8.78,6.84C190,232.51,195.24,232.38,200.38,232.7Z",
    transform: "translate(-1.36 -20.6)",
    fill: "#3e3e54"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M222.83,322.9a3.58,3.58,0,0,1,1.46-.34,3.42,3.42,0,0,1,1.31.46l12.22,6.35a7.8,7.8,0,0,1,2.41,1.66,2.66,2.66,0,0,1,.59,2.72,3.58,3.58,0,0,1-2.68,1.7,34.61,34.61,0,0,1-7,.69q-7.69.21-15.39,0a19.87,19.87,0,0,1-6.61-1,2.54,2.54,0,0,1-1.52-1.16,2.93,2.93,0,0,1-.11-1.47c.35-3.53-.19-6.24,3.71-6.81A54.54,54.54,0,0,0,222.83,322.9Z",
    transform: "translate(-1.36 -20.6)",
    fill: "#3e3e54"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M192.84,322.9a3.58,3.58,0,0,1,1.46-.34,3.42,3.42,0,0,1,1.31.46l12.23,6.35a7.75,7.75,0,0,1,2.4,1.66,2.66,2.66,0,0,1,.6,2.72,3.58,3.58,0,0,1-2.68,1.7,34.75,34.75,0,0,1-7,.69q-7.7.21-15.39,0a19.93,19.93,0,0,1-6.62-1,2.54,2.54,0,0,1-1.51-1.16,2.82,2.82,0,0,1-.12-1.47c.36-3.53-.18-6.24,3.71-6.81A54.39,54.39,0,0,0,192.84,322.9Z",
    transform: "translate(-1.36 -20.6)",
    fill: "#3e3e54"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 157.67,
    y: 252.66,
    width: 10.57,
    height: 46.94,
    fill: "#2f55d4"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 125.72,
    y: 293.95,
    width: 74.96,
    height: 6.39,
    rx: 3.2,
    fill: "#2f55d4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128.36,
    cy: 307.38,
    r: 7,
    fill: "#3e3e54"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 162.53,
    cy: 307.38,
    r: 7,
    fill: "#3e3e54"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 196.69,
    cy: 307.38,
    r: 7,
    fill: "#3e3e54"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M167.27,101s5.4-1.11,7.25,2,1.23,13.39,3.44,16.22,2.46,4.42.24,6.14-1.72,6.52-2.82,8-3.93,3.44-9.1,1.6S152,128.74,152,128.13,152.27,101.83,167.27,101Z",
    transform: "translate(-1.36 -20.6)",
    fill: "url(#linear-gradient-15)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M168.88,96c3.84,2.44,5.33,7.7,4,12.08s-4.9,7.8-9.06,9.66a3.88,3.88,0,0,0-2.16,1.61,3.22,3.22,0,0,0-.2,1.27c0,3.4.26,6.35-2.4,8.88a30,30,0,0,1-3.68,2.74,3.46,3.46,0,0,0-.82.7c-.76,1-.44,2.33-.34,3.54a8.74,8.74,0,0,1-6.6,8.93c-.83.18-1.68.24-2.49.5a3,3,0,0,0-1.92,1.53c-.45,1.08.08,2.33-.09,3.48-.26,1.67-1.91,2.76-3.5,3.29a12.44,12.44,0,0,1-9.81-.9c-1-.57-2.18-.56-3-1.43a6.75,6.75,0,0,1-1.5-3.74,19,19,0,0,1,.53-5.45l2.5-12.55c.65-3.29,1.59-7,4.52-8.59a14.05,14.05,0,0,0,2.85-1.5,6.07,6.07,0,0,0,1.56-3.28c.82-3.56,1.28-7.22,2.35-10.71s2.83-6.92,5.71-9.17c3.05-2.37,7-3.19,10.9-3.32,5.54-.19,9-1.8,12.57,2.43",
    transform: "translate(-1.36 -20.6)",
    fill: "#3e3e54"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M101.27,158.24s-2.21-.49-2.21,6.88S117.5,272.77,117.5,272.77s-1.72,3.69,15.23,3,71.53-1,71.53-1,4.91,0,5.4-7.13-10.07-8.36-10.07-8.36l-43.51-2L138.88,160Z",
    transform: "translate(-1.36 -20.6)",
    fill: "#2f55d4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M209.66,267.61c-.49,7.13-5.4,7.13-5.4,7.13s-35.26.16-57.89.6c-5.53.11-10.3.23-13.63.38-17,.74-15.24-3-15.24-3S99.06,172.49,99.06,165.12s2.22-6.88,2.22-6.88l23.48,1.07,14.12.65,17.2,97.33,43.51,2S210.16,260.48,209.66,267.61Z",
    transform: "translate(-1.36 -20.6)",
    fill: "url(#linear-gradient-16)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M209.66,267.61c-.49,7.13-5.4,7.13-5.4,7.13s-35.26.16-57.89.6c-4.85-.86-4.05-2.57-4.05-2.57s-18.44-100.28-18.44-107.65c0-3.16.41-4.88.88-5.81l14.12.65,17.2,97.33,43.51,2S210.16,260.48,209.66,267.61Z",
    transform: "translate(-1.36 -20.6)",
    fill: "url(#linear-gradient-17)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyzeReport4);
export default __webpack_public_path__ + "static/media/analyze_report_4.97156754f022c0ce5c82542bf02e1b86.svg";
export { ForwardRef as ReactComponent };